var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MaterialCard',{attrs:{"color":"green","full-width":""}},[_c('v-flex',[_vm._v("\n    "+_vm._s(_vm.authority.name)+"\n  ")]),_c('v-flex',[_vm._v("\n    "+_vm._s(_vm.authority.description)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }